// Heading ids shared by the renderer (remark plugin) and the table of contents,
// so anchors and TOC links always agree.

export function slugifyHeading(text) {
  return String(text)
    .toLowerCase()
    .replace(/`/g, '')
    .replace(/[^\p{L}\p{N}\s-]/gu, '')
    .trim()
    .replace(/\s+/g, '-');
}

export function createSlugger() {
  const seen = new Map();
  return (text) => {
    const base = slugifyHeading(text) || 'section';
    const n = seen.get(base) || 0;
    seen.set(base, n + 1);
    return n === 0 ? base : `${base}-${n}`;
  };
}

/** Extracts ## and ### headings (ids count every level, matching the renderer) (outside code fences and :::steps blocks) for the TOC. */
export function extractHeadings(markdown) {
  const slug = createSlugger();
  const out = [];
  let inFence = false;
  let directiveDepth = 0;
  let stepsDepth = -1;
  for (const line of String(markdown || '').split('\n')) {
    if (/^\s*(```|~~~)/.test(line)) { inFence = !inFence; continue; }
    if (inFence) continue;
    const open = line.match(/^:::(\w+)/);
    if (open) {
      directiveDepth++;
      if (open[1] === 'steps' && stepsDepth < 0) stepsDepth = directiveDepth;
      continue;
    }
    if (/^:::\s*$/.test(line)) {
      if (directiveDepth === stepsDepth) stepsDepth = -1;
      directiveDepth = Math.max(0, directiveDepth - 1);
      continue;
    }
    const m = line.match(/^(#{1,6})\s+(.+?)\s*#*\s*$/);
    if (!m) continue;
    const text = m[2].replace(/\[([^\]]+)\]\([^)]*\)/g, '$1').replace(/[*_`]/g, '');
    const id = slug(text);
    if (stepsDepth < 0 && (m[1].length === 2 || m[1].length === 3)) out.push({ depth: m[1].length, text, id });
  }
  return out;
}
